module.exports = __webpack_public_path__ + "img/dd1.f02f1dad.png";